import React, {useState} from 'react'
import { Snackbar } from '@mui/material';
import { Alert, AlertTitle } from '@mui/material';
import useClasses from '../../../helpers/useClasses';


const styles = theme => ({
  
});

const Toast = props => {
  const { id, severity, duration, title, message, horizontal, vertical, onDismissClick } = props;
  const [open, setOpen] = useState(true)
  const classes = useClasses(styles)
  
  return (
    <Snackbar
      key={id}
      open={open}
      autoHideDuration={duration}
      onClose={onDismissClick}
      anchorOrigin={{ vertical, horizontal }}
    >
      <Alert variant="filled" onClose={onDismissClick} severity={severity}>
        { title ? 
          <AlertTitle>{title}</AlertTitle>
          : null
        }
        {message}
      </Alert>
    </Snackbar>
  )
};

export default Toast